export const GMXV2_URL = "https://gmx.squids.live/gmx-synthetics-arbitrum/graphql";
export const GMXV1_URL = "https://api.studio.thegraph.com/query/52058/gmxv1-arbitrum-stats/version/latest";
export const VELA_API_URL = "https://api.vela.exchange/";
export const GTRADE_URL = "https://api.studio.thegraph.com/query/52058/gtrade-arbitrum-stats/version/latest";
